import { useFetch } from "~vue/api";
import type { RecordUiInteractionRequest, UiInteractionType } from "~vue/api/generated/ui-interactions";
import { ref } from "vue";

export function useUIInteractions() {
    const dismissPayload = ref<RecordUiInteractionRequest | null>(null);
    const { execute: executePost, error } = useFetch("/api/accounts/ui-interactions", { immediate: false }).post(dismissPayload).json();

    /**
     * Records the interaction, returning whether it actually reached the server.
     *
     * useFetch executes with `throwOnFailed = false`, so awaiting the POST resolves even on a 500
     * or a dropped connection — callers that must not proceed without a durable record have to
     * check the result rather than the absence of a rejection.
     */
    const createInteraction = async (interactionType: UiInteractionType): Promise<boolean> => {
        dismissPayload.value = { interaction_type: interactionType };
        await executePost();
        return !error.value;
    };

    return {
        createInteraction,
    };
}
